/* eslint-disable prefer-const */
/*
  Bang Confetti: Hackathon lần 2/2022
  Bản gốc: (HTML, CSS, vanillaJS) Szenia Zadvornykh: https://codepen.io/zadvorsky/pen/OJwQxo
  Bản chế: Được tạo ra bởi sử tùy hứng của HaiNH để có thể xài trong Presenter App.
  Ưu: 100% code in project, 0 xài package ngoài.
  Nhược: Nếu phải maintain nó đừng chửi em.
*/
import Point from './Point'
import Particle from './Particle'

// canvas settings
let viewWidth; let viewHeight
let drawingCanvas = null
let ctx = null
// eslint-disable-next-line prefer-const
let particles = []

function createParticles() {
  for (let i = 0; i < 48; i++) {
    let p0 = new Point(viewWidth * 0.5, viewHeight * 0.5)
    let p1 = new Point(Math.random() * viewWidth, Math.random() * viewHeight)
    let p2 = new Point(Math.random() * viewWidth, Math.random() * viewHeight)
    let p3 = new Point(Math.random() * viewWidth, viewHeight + 64)
    particles.push(new Particle(p0, p1, p2, p3))
  }
}
function checkParticlesComplete() {
  for (let i = 0; i < particles.length; i++) {
    if (particles[i].complete === false) return false
  }
  return true
}
function update() {
  particles.forEach((p) => {
    p.update()
  })
}
function draw() {
  ctx.clearRect(0, 0, viewWidth, viewHeight)
  particles.forEach((p) => {
    p.draw(ctx)
  })
}
function destroy() {
  particles.length = 0
  ctx = null
}
// eslint-disable-next-line import/export
export const loop = () => {
  if (checkParticlesComplete()) {
    destroy()
    return
  }
  update()
  draw()
  if (particles.length > 0 && ctx) requestAnimationFrame(loop)
}
// eslint-disable-next-line import/export
export const initDrawingCanvas = (canvas, w, h) => {
  drawingCanvas = canvas
  drawingCanvas.width = w
  drawingCanvas.height = h
  viewWidth = w
  viewHeight = h
  ctx = drawingCanvas.getContext('2d')
  ctx.clearRect(0, 0, viewWidth, viewHeight)
  createParticles()
}
